"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityDeleteMutation = void 0;
var client_1 = require("@apollo/client");
var entity_delete_mutation_name_1 = require("./entity-delete-mutation-name");
var entity_delete_mutation_field_name_1 = require("./entity-delete-mutation-field-name");
var entityDeleteMutation = function (definition) {
  return definition.update.mutation || (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      mutation ", "($id: ID!) {\n        ", "(id: $id)\n      }\n    "], ["\n      mutation ", "($id: ID!) {\n        ", "(id: $id)\n      }\n    "])), (0, entity_delete_mutation_name_1.entityDeleteMutationName)(definition), (0, entity_delete_mutation_field_name_1.entityDeleteMutationFieldName)(definition));
};
exports.entityDeleteMutation = entityDeleteMutation;
var templateObject_1;